import { createContext } from 'react';
import type { Område } from '@origo/seksjon';

/** Mål-node for dra-og-slipp av et egendefinert område. */
export type OmrådeDragTarget =
    | { parentType: 'Delområdetype'; parentId: string; navn: string }
    | { parentType: 'Delområde'; parentId: string; navn: string; delomradetype: string };

export interface NavDragContextValue {
    draggedOmråde: Område | null;
    forceExpandedIds: ReadonlySet<string>;
    dragOverId: string | null;
    /** Noden som ble sluppet over — fremhevet mens drop-menyen er åpen. */
    dropTargetId: string | null;
    isDragEnabled: boolean;
    onEgendefinertDragStart: (omrade: Område, e: React.DragEvent<HTMLDivElement>) => void;
    onEgendefinertDragEnd: (e: React.DragEvent<HTMLDivElement>) => void;
    onTargetDragEnter: (nodeId: string, e: React.DragEvent<HTMLDivElement>) => void;
    onTargetDragOver: (target: OmrådeDragTarget, e: React.DragEvent<HTMLDivElement>) => void;
    onTargetDragLeave: (nodeId: string, e: React.DragEvent<HTMLDivElement>) => void;
    onTargetDrop: (target: OmrådeDragTarget, e: React.DragEvent<HTMLDivElement>) => void;
}

export const NavDragContext = createContext<NavDragContextValue>({
    draggedOmråde: null,
    forceExpandedIds: new Set(),
    dragOverId: null,
    dropTargetId: null,
    isDragEnabled: false,
    onEgendefinertDragStart: () => undefined,
    onEgendefinertDragEnd: () => undefined,
    onTargetDragEnter: () => undefined,
    onTargetDragOver: () => undefined,
    onTargetDragLeave: () => undefined,
    onTargetDrop: () => undefined,
});
